import * as Types from 'graphql/types';
import {Options, NodeRenderer} from '@contentful/rich-text-react-renderer';
import {Box} from '@mui/material';

const renderData = (data: Types.News['content']) => {
  const nodeRenderer: NodeRenderer = () => <Box>{data}</Box>;
  return nodeRenderer;
};

export const getOptionsLabel = (data: Types.News['content']): Options => {
  const options: Options = {
    renderNode: {
      data: renderData(data),
    },
  };
  return options;
};
